var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home_page"}},[_c('NavigationBar'),_c('MainNavigation'),_c('RecentlyCourse'),_c('UjoyPlusCourse'),_c('LearningPath'),_c('RecentlyRecommendCourse'),_c('TrainingCourse'),_c('SiteDescription')],1)}
var staticRenderFns = []

export { render, staticRenderFns }